import { getPreference } from "./getPreference";

export const get_bewohner_station = ( my_station: any, callback: Function ) => {
  getPreference(
    'senioren.bewohner',
    ( value: any )  =>
      callback(
        JSON.parse( value ).filter(
          ( entry: any ) => entry.betriebe_bewohner_wb === my_station
        )
      )
  );
}
